<div class="group">
    <input (input)="onChange($event.target.value)" [value]="text" type="text" required="required" [maxLength]="maxChars" /><span class="highlight"></span><span class="bar"></span>
    <label>{{label}}</label>
</div>